module.exports = __webpack_public_path__ + "static/media/20.1ac9bda7.png";